import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { actionToggleFooter, actionToggleNavBar, actionToggleSideBar } from "../store/action/LayoutActionSupervisor";
import { formatDate, actionGetallStats, isLoginSupervisorAccessRightsLoaded, actionGetVFASPsForSearch } from "../store/action/RemoteActionSupervisor";
import translate from "../i18n/translate";
import connect from "react-redux/es/components/connect";
import { useNavigate } from "react-router-dom";

const HomeSupervisor = (props) => {
    const [language, setLanguage] = useState("");
    const [statsList, setStatsList] = useState({});
    const [isAccessRightsLoaded, setIsAccessRightsLoaded] = useState(false);
    const navigate = useNavigate();

    const styles = {
        flex: { display: 'flex' },
        flexColumn: { display: 'flex', flexDirection: 'column' },
        leftCol: { flex: 1, marginRight: '0.5em' },
        rightCol: { flex: 1, marginLeft: '0.5em' },
        singleCol: { marginTop: '1em', marginBottom: '1em' },
        fieldset: { margin: '2px', border: '1px solid silver', padding: '8px', borderRadius: '4px' },
        legend: { padding: '3px 6px' },
    };
    
    useEffect(() => {
        if (props?.statsData?.AggregateStats) {
            setStatsList(props.statsData);
        }
    }, [props.statsData]);

    useEffect(() => {
        if (props && props.supervisorError && props?.supervisorError.toString().includes("403")) {
            localStorage.removeItem("supervisortoken");
            localStorage.removeItem("supervisorid");
            navigate("/supervisorlogin");
        }
    }, [props.supervisorError]);

    useEffect(() => {
        if (props?.supervisor?.length > 0 && isAccessRightsLoaded) {
            props.actionGetallStats();
            props.actionGetVFASPsForSearch();
        }
    }, [props.supervisor]);

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        props.actionToggleNavBar(true);
        props.actionToggleSideBar(true);
        props.actionToggleFooter(true);
        if (isLoginSupervisorAccessRightsLoaded()) {
            setIsAccessRightsLoaded(true);
        }
    }, []);

    return (props?.supervisor?.length > 0 && isAccessRightsLoaded) ? (
        <div className="user-panel">
            <div style={styles.flex}>

                {/* Left Panel */}
                <div style={styles.leftCol}>
                    {/* IVFAO Buy */}
                    <div className="gaps-1x" />
                    <Typography variant="h5" component="h2">
                        {translate('IVFAOBuy')}
                    </Typography>
                    <fieldset style={styles.fieldset}>
                        <div style={styles.flex}>
                            {translate('Weekly')}:&nbsp;{statsList?.AggregateStats?.IVFAOWeeklyBuy}&nbsp;{translate('Agatha')}
                        </div>
                        <div style={styles.flex}>
                            {translate('Monthly')}:&nbsp;{statsList?.AggregateStats?.IVFAOMonthlyBuy}&nbsp;{translate('Agatha')}
                        </div>
                        <div style={styles.flex}>
                            {translate('Yearly')}:&nbsp;{statsList?.AggregateStats?.IVFAOYearlyBuy}&nbsp;{translate('Agatha')}
                        </div>
                    </fieldset>
                </div>

                {/* Right Panel */}
                <div style={styles.rightCol}>

                </div>

            </div>
        </div>
    ) : "";
}

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
        supervisor: state.remote.supervisor,
        supervisorError: state.remote.supervisorError,
        statsData: state.remote.statsData
    };
};

export default connect(mapStateToProps, {
    actionToggleNavBar,
    actionToggleSideBar,
    actionToggleFooter,
    actionGetVFASPsForSearch,
    actionGetallStats
})(HomeSupervisor);
